import sObjetos from '@/aplicacao/_servicos/objetos'
import cCategoria from '@/aplicacao/modulos/cartas-de-planejamento/_constantes/Categoria'

function State(load) {

    this.visivel = false

    this.carta = {
        id: -1,
        categoriaId: '',
        mercadoId: '',
        arquivo: '',
        removerArquivo: false,
        upload: null,
        data: { ano: '', mes: '' },
        criadoEm: null,
    }

    this.erros = []

}

const mutations = {

    resetar(state) { sObjetos.preencher(state, new State()) },

    setVisivel(state, payload) { state.visivel = payload },

    setModo(state, payload) { state.modo = payload },

    setCartaId(state, payload) { state.carta.id = payload },
    setCartaCategoriaId(state, payload) { state.carta.categoriaId = payload },
    setCartaMercadoId(state, payload) { state.carta.mercadoId = payload },
    setCartaArquivo(state, payload) { state.carta.arquivo = payload },
    setCartaRemoverArquivo(state, payload) { state.carta.removerArquivo = payload },
    setCartaUpload(state, payload) { state.carta.upload = payload },
    setCartaDataAno(state, payload) { state.carta.data.ano = payload },
    setCartaDataMes(state, payload) { state.carta.data.mes = payload },
    setCartaCriadoEm(state, payload) { state.carta.criadoEm = payload },

    setErros(state, payload) { state.erros = payload },

}

const actions = {

    resetar({ commit }) {
        commit('resetar')
    },

    setCartaId({ commit }, payload) { commit('setCartaId', payload) },
    setCartaCategoriaId({ commit }, payload) {
        let valor = isNaN(payload) ? '' : parseInt(payload)
        commit('setCartaCategoriaId', valor)
        if (cCategoria.CARTA_DE_VENDAS !== valor) {
            commit('setCartaMercadoId', '')
        }
    },
    setCartaMercadoId({ commit }, payload) { commit('setCartaMercadoId', isNaN(payload) ? '' : parseInt(payload)) },
    setCartaArquivo({ commit }, payload) { commit('setCartaArquivo', payload) },
    setCartaRemoverArquivo({ commit }, payload) { commit('setCartaRemoverArquivo', payload) },
    setCartaUpload({ commit }, payload) { commit('setCartaUpload', payload) },
    setCartaDataAno({ commit }, payload) { commit('setCartaDataAno', payload) },
    setCartaDataMes({ commit }, payload) { commit('setCartaDataMes', payload) },
    setCartaCriadoEm({ commit }, payload) { commit('setCartaCriadoEm', payload) },

    mostrar({ commit }) {
        commit('setVisivel', true)
    },

    ocultar({ commit, dispatch }) {
        commit('setVisivel', false)
        dispatch('resetar')
    },

    criar({ commit, dispatch }) {
        dispatch('resetar')
        dispatch('mostrar')
    },

    editar({ commit, dispatch }, dados) {

        commit('setCartaId', dados.id)
        commit('setCartaCategoriaId', dados.categoria.id)
        commit('setCartaMercadoId', dados.mercado ? dados.mercado.id : '')
        commit('setCartaArquivo', dados.arquivo)
        commit('setCartaRemoverArquivo', false)
        commit('setCartaUpload', null)
        commit('setCartaDataAno', dados.data.ano)
        commit('setCartaDataMes', dados.data.mes)
        commit('setCartaCriadoEm', dados.criadoEm)

        dispatch('mostrar')

    },

    adicionarErro({ state, commit }, payload) {
        let erros = state.erros
        erros.push(payload)
        commit('setErros', erros)
    },

    limparErros({ commit }) {
        commit('setErros', [])
    },

}

const getters = {

    titulo: (state, getters) => (getters.modoCriacao ? 'Cadastro' : 'Edição') + ' de arquivo',

    modoCriacao: state => -1 === state.carta.id,
    modoEdicao: (state, getters) => !getters.modoCriacao,

    temMercado: state => cCategoria.CARTA_DE_VENDAS === state.carta.categoriaId,

    temErro: state => 0 < state.erros.length,

}

export default {
    state: new State(),
    mutations,
    actions,
    getters,
}
